import getString from './strings';

class CustomLoadingCellRenderer {
  init(params) {
    this.eGui = document.createElement('div');
    this.eGui.classList.add('custom-loading-cell-renderer-container');
    //Using svg from figma as spinner as kat-spinner is not working in customLoadingCellRenderer not sure why
    this.eGui.innerHTML = `
      <div class="dg-custom-loading-cell-renderer">
      <svg class="dg-custom-loading-cell-spinner" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10" stroke="#0A6FC2" stroke-width="2"/>
      </svg>
      <span class="dg-loading-message">${
        params.loadingMessage || getString('dg-loading')
      } </span>
      </div>
    `;
  }

  getGui() {
    return this.eGui;
  }
}

export { CustomLoadingCellRenderer };
